module.exports = __webpack_public_path__ + "static/assets/11d9852911e7b7661cf97a5a1b0ac8b6.png";